import { Pipe, PipeTransform } from '@angular/core';
import { dateHelper } from '../helpers/date-helper';

const WEEK_DAYS = {
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSDAY: 4,
  FRIDAY: 5,
  SATURDAY: 6,
  SUNDAY: 7,
};

@Pipe({
  standalone: false,
  name: 'cDayNameByType'
})
export class DayNameByTypePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value === 'WEEKDAYS') {
      return dateHelper.getGroupWeekdaysName();
    }

    return dateHelper.getDayName(WEEK_DAYS[value]);
  }

}
